import PreviewTemplate from './../../components/before-register/PreviewTemplate.vue'

export default [
    {
      path: '/:lang?/get-started/preview-template/:template',
      name: 'preview-template',
      component: PreviewTemplate,
      props: castRouteParams,
    }
  ]

  function castRouteParams(route) {
    return {
      template: Number(route.params.template),
    };
  }